const FunctionTitles = (newTitle) => {
  return (document.title = newTitle);
};

export default FunctionTitles;
